import React from 'react';
import { Rating } from 'semantic-ui-react';
import 'semantic-ui-less/definitions/modules/rating.less';

export default Rating;
